module.exports = __webpack_public_path__ + "img/C@2x.93d89e5b.jpg";